export var CategoryTypes;
(function (CategoryTypes) {
    CategoryTypes["Navigation"] = "navigation";
    CategoryTypes["MenuLoggedOut"] = "menu_logged_out";
    CategoryTypes["MenuLogged"] = "menu_logged";
    CategoryTypes["News"] = "news";
})(CategoryTypes || (CategoryTypes = {}));
//# sourceMappingURL=Category.js.map